import { Base } from '@gate31/core/src/libs/BaseComponent';
import { CreateAccountFormDesk } from '@gate31/desktop/components/CreateAccountFormDesk/CreateAccountFormDesk';

export default class CreateAccountDesk extends Base<HTMLElement> {
    static cn = new Base.BuildCn('CreateAccountDesk');

    cb?: () => void

    constructor(node: HTMLElement, cb?: () => void) {
        super(node);

        this.cb = cb;

        this.callbackConnection();
    }

    callbackConnection() {
        // eslint-disable-next-line
        new CreateAccountFormDesk({
            node: CreateAccountFormDesk.querySelector(CreateAccountFormDesk.cn.toSelector()),
            source: 'Site',
            successHandle: () => {
                this.cb?.();
                this.openResultMessage?.();
            }
        });
    }

    openResultMessage() {
        const successNode = document.querySelector(CreateAccountDesk.cn.setElem('success').toSelector());
        const bodyNode = document.querySelector(CreateAccountDesk.cn.setElem('form-body').toSelector());

        const successHiddenClass = CreateAccountDesk.cn.setElem('success').setMode({ hidden: true }).toString();
        const bodyHiddenClass = CreateAccountDesk.cn.setElem('form-body').setMode({ hidden: true }).toString();

        successNode?.classList.remove(successHiddenClass);
        bodyNode?.classList.add(bodyHiddenClass);

        setTimeout(() => {
            this.redirectToAccount();
        }, 7000);
    }

    redirectToAccount() {
        window.location.href = '/client_account/login';
    }
}
